import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { JwtModule } from '@auth0/angular-jwt';
import Aura from '@primeng/themes/aura';

import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental';
import { withDevtools } from '@tanstack/angular-query-experimental/devtools'

import { ApiRequestInterceptor } from '@core/interceptor/api-request.interceptor';
import { EncryptionService } from '@shared/services/encryption.service';
import { UserProfile } from '@core/types';
import { STORE } from '@core/constans';
import { routes } from './app.routes';


type ProfileState = {
  profile: UserProfile;
};

export function getToken(): any {
  const savedState = localStorage.getItem(STORE.profile);
  if (savedState) {
    try {
      const encryptionService = new EncryptionService();
      const state: ProfileState = encryptionService.decryptJson(savedState);
      return state?.profile?.token?.value || '';
    } catch (e) {
      // Si hay un error de parseo o lo que sea, mejor no devolver nada
      return '';
    }
  }
  return '';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([ApiRequestInterceptor])
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'es',
      lang: 'es'
    }),
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
          // Desactivar capas CSS para evitar problemas de especificidad
          cssLayer: false
        }
      }
    }),
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: getToken
        },
      })
    ),
    // provideAngularQuery(new QueryClient({
    //   defaultOptions: {
    //     queries: {
    //       staleTime: 1000 * 60 * 5, // 5 minutos
    //       gcTime: 1000 * 60 * 30, // 30 minutos
    //       retry: 1,
    //       refetchOnWindowFocus: false,
    //     },
    //   },
    // }))
    provideTanStackQuery(
      new QueryClient(),
      withDevtools(() => ({ loadDevtools: 'auto'})),
    )
  ]
};
